// @core/api/endpoints/billing/list_prices.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPricesResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List prices
 * Returns a paginated list of prices with optional filtering by product, currency, and active status.
 */
export async function ListPrices(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPricesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/prices`;
  const requestOptions = options;
  return client.get<ListPricesResponse>(requestPath, { ...requestOptions, params });
}
